import { render, staticRenderFns } from "./RecordViewMain.vue?vue&type=template&id=3b147587&"
import script from "./RecordViewMain.vue?vue&type=script&lang=js&"
export * from "./RecordViewMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports